import { PropTypes } from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import useStyles from './useStyles';

export const MobileResourceAllocationTitle = ({ resourceAllocation }) => {
  const classes = useStyles();
  const { role, user } = resourceAllocation;

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        <span className={classes.roleName}>
          {user ? (
            <span className={classes.userName}>{user.user.displayText}</span>
          ) : (
            <FormattedMessage id="mobileResourcePlanning.noRole" />
          )}
          (
          {role ? (
            <span className={classes.roleName}>{role.displayText}</span>
          ) : (
            <FormattedMessage id="mobileResourcePlanning.anyRole" />
          )}
          )
        </span>
      </div>
    </div>
  );
};

MobileResourceAllocationTitle.propTypes = {
  resourceAllocation: PropTypes.object
};

export default MobileResourceAllocationTitle;
